import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import MapPage from './components/MapPage';
import LineupsPage from './components/LineupsPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import SubmitClip from './components/SubmitClip';
import NavBar from './components/NavBar';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-900 text-white flex flex-col">
        <NavBar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/map/:mapName" element={<MapPage />} />
            <Route path="/map/:mapName/:side" element={<LineupsPage />} />
            <Route path="/submit-clip" element={<SubmitClip />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
